import { render, staticRenderFns } from "./casting-calls.vue?vue&type=template&id=273f6b5f&scoped=true&"
import script from "./casting-calls.vue?vue&type=script&lang=ts&"
export * from "./casting-calls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273f6b5f",
  null
  
)

export default component.exports